export default "__VITE_ASSET__xzpaS_38__"